






























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class Levels extends Vue {
    @Prop() modelWrapper!: any;
    @Prop() row!: any;
    @Prop() readOnly: boolean;

    componentKey: number = 1;
    modelKey: string = 'levels';

    get datum() {
        var data = this.modelWrapper;

        this.row.parentKey.split('.').forEach((key) => {
            if(!data[key]) {
                data[key] = {};
            }
            data = data[key];
        })

        if(!data[this.modelKey]) {
            data[this.modelKey] = [];
        }

        return data;
    }

    deleteLevel(index) {
        this.datum[this.modelKey].splice(index,1);
        this.componentKey  += 1;
        this.$emit('change', true); 
    }

    addLevel() {
        this.datum[this.modelKey].push({});
        this.componentKey  += 1; 
        this.$emit('change', true);
    }

    toggleInput(value, model) {
        if(value.target.checked) {
            model.baselineunknown = true;
            model.baseline = null;
        }
        else
            model.baselineunknown = false;
    }
    
}
